<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 text-center text-md-start">
        © 2014 - {{ currentYear }} {{ appName }} By <span class="fw-semibold">{{ credits.name }}</span>
      </div>
      <div class="col-md-6">
        <div class="text-md-end text-center">
          <span class="fw-semibold">{{ version }}</span>
          <span class="text-muted ms-2" style="font-size: 0.85rem;" title="Fecha de compilación: {{ buildDate }}">
            ({{ buildDate }})
          </span>
        </div>
      </div>
    </div>
  </div>
</footer>
